export default __webpack_public_path__ + "static/media/480_store01-jp-mobile.b675a3c2.png";